const GoogleAdSquare = () => {
  return (
    <>
      <div className="rbt-callto-action rbt-cta-default style-4 bg-gradient-3 mt--20">
        <a href="https://www.tkqlhce.com/click-101154220-15552670" target="_top">
          <img src="https://www.tqlkg.com/image-101154220-15552670" width="300" height="250" alt="" border="0" /></a>
      </div>
    </>
  );
};

export default GoogleAdSquare;
